/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Create_TitleInputs */

const en_resumes_create_title = /** @type {(inputs: Resumes_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a resume`)
};

const de_resumes_create_title = /** @type {(inputs: Resumes_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf erstellen`)
};

const fr_resumes_create_title = /** @type {(inputs: Resumes_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un CV`)
};

const es_resumes_create_title = /** @type {(inputs: Resumes_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear un currículum`)
};

const it_resumes_create_title = /** @type {(inputs: Resumes_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un curriculum`)
};

const nl_resumes_create_title = /** @type {(inputs: Resumes_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een CV`)
};

const pl_resumes_create_title = /** @type {(inputs: Resumes_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz CV`)
};

const fi_resumes_create_title = /** @type {(inputs: Resumes_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo ansioluettelo`)
};

const da_resumes_create_title = /** @type {(inputs: Resumes_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opret et CV`)
};

const sv_resumes_create_title = /** @type {(inputs: Resumes_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapa ett CV`)
};

/**
* | output |
* | --- |
* | "Create a resume" |
*
* @param {Resumes_Create_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_create_title = /** @type {((inputs?: Resumes_Create_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Create_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_create_title(inputs)
	if (locale === "fr") return fr_resumes_create_title(inputs)
	if (locale === "es") return es_resumes_create_title(inputs)
	if (locale === "it") return it_resumes_create_title(inputs)
	if (locale === "nl") return nl_resumes_create_title(inputs)
	if (locale === "pl") return pl_resumes_create_title(inputs)
	if (locale === "fi") return fi_resumes_create_title(inputs)
	if (locale === "da") return da_resumes_create_title(inputs)
	if (locale === "sv") return sv_resumes_create_title(inputs)
	return en_resumes_create_title(inputs)
});